export const COMMENT_PERMISSION = "repo:update";
export const ACTION_PERMISSION = "repo:force";
export const PIRUM_USER_PERMISSION = "repo:support";
